<template>
    <div class="panel">
        <el-tabs v-model="activeName" class="fx-g1 inner_tags-page fx-col">
            <el-tab-pane label="背景管理" name="background">
                <component :is="background" :attr="{type: 3}"></component>
            </el-tab-pane>
            <el-tab-pane label="造型管理" name="costume">
                <component :is="costume" :attr="{type: 2}"></component>
            </el-tab-pane>
            <el-tab-pane label="声音管理" name="sound">
                <component :is="sound" :attr="{type: 4}"></component>
            </el-tab-pane>
            <el-tab-pane label="角色管理" name="sprite">
                <component :is="sprite" :attr="{type: 1}"></component>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<style scoped>
.panel_navs {
    height: 100%;
}
</style>


<script>


    export default {
        components: {
        },
        props: [
            "attr"
        ],
        data() {
            return {
                activeName: "background",
                background: () => import("./MaterialList"),
                sprite: () => import("./MaterialList"),
                costume: () => import("./MaterialList"),
                sound: () => import("./MaterialList"),
            }

        },
        computed: {
        },
        methods: {
        },
        created() {
        }
    }
</script>
